import React from 'react';

function Name() {

	return (
		<>
		<div className="oM-c">
			<div className="p-0  pr">
				<div className="container">
					<div class="bg mt-2">
						<div class="input-cont">
							<input type="text" name="name" autocomplete="off" required />
							<label for="name" class="label-name">
								<span class="content-name">
									Product Name*
								</span>
							</label>
						</div>
					</div>
					<a href="/enterProduct/enter-Details"><div className="bg-theme conti">
						Continue
					</div></a>
				</div>


			</div>
		</div>

		</>
	)
}




export default Name;